import React from "react";

import OldPortalHome from "Portal/PortalHome/View";
import NewPortalHome from "Portal/NewPortal/PortalHome/View";

const PortalHomeRouter = ({ showNewPortal, ...props }) => {
  const Component = showNewPortal ? NewPortalHome : OldPortalHome;
  return <Component {...props} />;
};

export default PortalHomeRouter;
